import React from 'react'
import * as S from './styled'

export interface MapBullet {
  color: 'yellow' | 'blue' | 'gray'
  text: string
}

export const MapBullets: React.FC<{ bullets: MapBullet[] }> = ({ bullets }) => (
  <S.KeyWrapper>
    {bullets.map(({ color, text }) => {
      return <KeyItem key={color} color={color} text={text} />
    })}
  </S.KeyWrapper>
)

const KeyItem = ({ color, text }: { color: string; text: string }) => (
  <div>
    <div>
      <S.Bullet color={color} />
    </div>
    <S.BulletText>{text}</S.BulletText>
  </div>
)
